import { ComponentPropsWithoutRef } from 'react';

import { PaymentInstrumentIcon } from '@ocx-app/components/payment-instrument-icon';

import { PaymentInstrumentType } from '@ocx/graphql';
import {
  CardNetwork,
  CardNumberFieldEndAdornmentSlotProps,
  CardNumberField as CardNumberFieldBase,
} from '@ocx/ui-forms';

const networkToPaymentInstrumentType: Record<CardNetwork, PaymentInstrumentType> = {
  amex: PaymentInstrumentType.AmericanExpress,
  dinersclub: PaymentInstrumentType.DinersClub,
  discover: PaymentInstrumentType.Discover,
  elo: PaymentInstrumentType.Elo,
  hipercard: PaymentInstrumentType.Unknown,
  jcb: PaymentInstrumentType.Jcb,
  laser: PaymentInstrumentType.Laser,
  maestro: PaymentInstrumentType.Maestro,
  mastercard: PaymentInstrumentType.Mastercard,
  unionpay: PaymentInstrumentType.ChinaUnionPay,
  visa: PaymentInstrumentType.Visa,
};

const CardPaymentInstrumentIcon = (props: CardNumberFieldEndAdornmentSlotProps) => {
  const { network } = props;
  const type = network ? networkToPaymentInstrumentType[network] : PaymentInstrumentType.Unknown;

  return <PaymentInstrumentIcon type={type} />;
};

export const CardNumberField = (
  props: Omit<ComponentPropsWithoutRef<typeof CardNumberFieldBase>, 'endAdornmentSlot'>,
) => {
  return <CardNumberFieldBase endAdornmentSlot={CardPaymentInstrumentIcon} {...props} />;
};
